import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { HttpModule } from '@angular/http';

//import { MatSelectSearchModule } from './mat-select-search/mat-select-search.module';

//routing
import { routing } from './app.routes';

//components
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { LoadingComponent } from './loading-spinner/loading.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashHomeComponent } from './dashboard/dash-home.component';
// import { BrokerDashboardComponent } from './dashboard/broker-dashboard.comoponent';
// import { BrokerDashHomeComponent } from './dashboard/broker-dash-home.comoponent';
import { NotificationComponent } from './notification/notification.component';
import { PaginationComponent } from './shared/pagination.component';
import { PasswordResendComponent } from './login/password-resend.component';
import { ProfileComponent } from './profile/profile.component';

//import * as GoogleChart from 'angular2-google-chart/directives/angular2-google-chart.directive';

import {GoogleChart} from './shared/angular2-google-chart.directive';
//services used by whole application
import { AccountService } from './shared/account.service';
import { AuthService } from './shared/auth.service';
import { BackendService } from './shared/backend.service';
import { FilterService } from './shared/filter.service';
import { LoadingService } from './loading-spinner/loading.service';
import { NotificationService } from './notification/notification.service';
import { OrderByService } from './shared/orderby.service';
import { PaginationService } from './shared/pagination.service';
import { SearchService } from './shared/search.service';
import { Utilities } from './shared/utilities.service';
//import { NgxDatatableModule } from '@swimlane/ngx-datatable';
//guards
import { AuthGuard } from './guards/auth.guard';
// import { PositionsContainerComponent } from './menu/positions/positions-container.component';
// import { PositionsComponent } from './menu/positions/positions.component';
// import { DetailedPositionsComponent } from './menu/positions/detailed-positions.component';

// import { TransactionsContainerComponent } from './menu/transactions/transactions-container.component';
// import { TransactionsComponent } from './menu/transactions/transactions.component';
// import { DetailedTransactionsComponent } from './menu/transactions/detailed-transactions.component';
// import { TradingComponent } from './menu/trading/trading.component';
// import { DocumentsComponent } from './menu/documents/documents.component';
//import { MomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';


 //import {MatNativeDateModule, MatRippleModule,MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
  import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

// import { OverviewComponent } from './menu/overview/overview.component';
//import { DeviceDetectorModule } from 'ngx-device-detector';
import { AccounttransferComponent } from './accounttransfer/accounttransfer.component';
import { AccountdisbursementComponent } from './accountdisbursement/accountdisbursement.component';
import { PositionsComponent } from './positions/positions.component';
import { PositionsContainerComponent } from './positions/positions-container.component';
import { AccountactivityComponent } from './accountactivity/accountactivity.component';
import { DocumentsComponent } from './documents/documents.component';
// import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
//import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ConfirmModifyComponent } from './profile/confirmmodify/confirmmodify.component';
import { ResetQuestionsComponent } from './login/reset-questions.component';
import { PopupdisplayComponent } from './popupdisplay/popupdisplay.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
//import { MomentModule } from 'angular2-moment';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TimeoutComponent } from './timeout/timeout.component';
import { ContactUsDialogComponent } from './contact-us/contact-us.component';
import { SignupComponent } from './signup/signup.component';

import { MaterialModule } from './shared/material.module';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocummentscontainerComponent } from './documents/docummentscontainer/docummentscontainer.component';
import { StandardDocumentComponent } from './documents/standard-document/standard-document.component';

@NgModule({
  declarations: [
    AppComponent,
    LoadingComponent,
    LoginComponent,
    DashboardComponent,
    DashHomeComponent,
    // BrokerDashboardComponent,
    // BrokerDashHomeComponent,
    NotificationComponent,
    PaginationComponent,
    PasswordResendComponent,
    ProfileComponent,
    // PositionsContainerComponent,
    // PositionsComponent,
    // DetailedPositionsComponent,
    // TransactionsContainerComponent,
    // TransactionsComponent,
    // DetailedTransactionsComponent,
    // TradingComponent,
    // DocumentsComponent,
    // OverviewComponent,
    GoogleChart,
    AccounttransferComponent,
    AccountdisbursementComponent,
    PositionsComponent,
    PositionsContainerComponent,
    AccountactivityComponent,
    DocumentsComponent,
    ConfirmModifyComponent,
    ResetQuestionsComponent,
    PopupdisplayComponent,
    TimeoutComponent,
    ContactUsDialogComponent,
    SignupComponent,
    DocummentscontainerComponent,
    StandardDocumentComponent
   
   
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    routing,
    HttpModule,
       // BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        routing,
        // DropDownsModule,
        //MatSelectSearchModule,
        MaterialModule,
        //NgxMatSelectSearchModule,
       // NgxDatatableModule,
        
        //MatNativeDateModule, 

        //DeviceDetectorModule.forRoot(),
        NgIdleKeepaliveModule.forRoot(),
        //MomentModule,
        ModalModule.forRoot()
        
  ],
  entryComponents: [AppComponent, ConfirmModifyComponent,PopupdisplayComponent,ContactUsDialogComponent],
  providers: [
    AccountService,
    AuthGuard,
    AuthService,
    BackendService,
    CurrencyPipe,
    FilterService,
    LoadingService,
    NotificationService,
    OrderByService,
    PaginationService,
    SearchService,
    Utilities,
    DatePipe,
    DecimalPipe ,
    {provide:MAT_DIALOG_DATA,useValue:{}},
    { provide: MatDialogRef, useValue: {} }
    
   // {provide: LocationStrategy, useClass: HashLocationStrategy},
    
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
